import { toast } from "sonner";
import { ApiError } from "./api";

/** Validation and conflicts need the form context; transport failures are transient. */
export function showOperationError(
  error: unknown,
  message: string,
  setInlineError: (message: string) => void,
) {
  if (error instanceof ApiError && [400, 409, 422].includes(error.status)) {
    setInlineError(message);
  } else {
    toast.error(message, { duration: 8000 });
  }
}
